import type { Application, JobPosition, JobPosting } from '@/types';
import { useDashboardMetrics, type Period } from '@/hooks/useDashboardMetrics';

/**
 * Fase 2b (interim): funnel, channel, TTH, trend from loaded application rows.
 * SME dashboard feeds this from `useDashboardData` (applications-list prefetch).
 * Replace with `useDashboardAnalyticsQuery` when `GET …/dashboard/analytics` ships.
 */
export function useDashboardChartMetrics(
  applications: Application[],
  positions: JobPosition[],
  postings: JobPosting[],
  period: Period,
  options?: { hasProcessingCredits?: boolean },
) {
  const metrics = useDashboardMetrics(applications, positions, postings, period, options);
  return metrics;
}

export type DashboardChartMetrics = ReturnType<typeof useDashboardChartMetrics>;
